<template>
  <div class="navigation">
    <div class="display-settings">
      <i
        class="icon icon-list"
        :class="{active : displayMode == 'list'}"
        @click="changeDisplayMode('list')"/>
      <i
        class="icon icon-grid"
        :class="{active : displayMode == 'grid'}"
        @click="changeDisplayMode('grid')"/>
    </div>

    <div class="cursor">
      <b>{{ queryInfo.total }}</b> results
    </div>

    <div class="sort">
      <label for="orderby">
        Order by
      </label>

      <select id="orderby" v-model="orderby">
        <option value="creationdate">Creation date</option>
        <option value="importdate">Import date</option>
        <option value="updatedate">Update date</option>
        <option value="privatealias">Private alias</option>
        <option value="publicalias">Public alias</option>
        <option value="uri">URI</option>
        <option value="visit">Number of visit</option>
      </select>

      <ButtonToggle
        iconStateFalse="icon-sort-descending"
        iconStateTrue="icon-sort-ascending"
        v-model="orderasc"
        title="Change sort order"
      ></ButtonToggle>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonToggle from '@/components/common/ButtonToggle'

@Component({
  name: 'Navigation',
  props: ['displayMode'],
  components: {
    ButtonToggle
  }
})
class Navigation extends Vue {
  @Prop displayMode

  get last() {
    if (this.queryInfo.first + this.queryInfo.limit <= this.queryInfo.total) {
      return this.queryInfo.first + this.queryInfo.limit
    }
    return this.queryInfo.total
  }

  get orderby() {
    return this.queryInfo.orderby
  }

  set orderby(value) {
    this.changeOrderBy(value)
  }

  get orderasc() {
    return this.queryInfo.orderasc
  }

  set orderasc(value) {
    this.changeOrderAsc(value)
  }

  changeDisplayMode(mode) {
    this.$emit('changeDisplayMode', mode)
  }
}

export default Navigation
</script>

<style lang="less" scoped>
.navigation {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 2 * var(--margin--medium));
  max-width: 1200px;

  margin: var(--margin--small) var(--margin--medium);
  padding: var(--margin--small) var(--margin--medium);

  color: var(--color-text);
  font-size: 130%;
  text-align: center;

  background-color: rgba(0, 0, 0, 0.07);
  border: 1px solid var(--color-separation-border);
  box-shadow: var(--default-ui-element-shadow);
  position: relative;
}

.display-settings {
  flex: 2;
  text-align: left;

  .icon {
    opacity: 0.3;
    margin-right: var(--margin--tiny);
  }
  .icon.active {
    opacity: inherit;
  }
}

.sort {
  flex: 2;
  margin-left: 15px;

  text-align: right;

  label {
    font-size: 14px;
  }
  select {
    margin-left: var(--margin--small);
    margin-right: var(--margin--small);
  }
}
</style>
